/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_NumberInputs */

const en_admin_resources_number = /** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

const de_admin_resources_number = /** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nummer`)
};

const es_admin_resources_number = /** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número`)
};

const fr_admin_resources_number = /** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro`)
};

const nl_admin_resources_number = /** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nummer`)
};

/** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */
const it_admin_resources_number = en_admin_resources_number;

/** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */
const pt_br2_admin_resources_number = en_admin_resources_number;

/** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */
const pl_admin_resources_number = en_admin_resources_number;

/** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */
const hu_admin_resources_number = en_admin_resources_number;

/** @type {(inputs: Admin_Resources_NumberInputs) => LocalizedString} */
const ro_admin_resources_number = en_admin_resources_number;

/**
* | output |
* | --- |
* | "Number" |
*
* @param {Admin_Resources_NumberInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_number = /** @type {((inputs?: Admin_Resources_NumberInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_NumberInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_number(inputs)
	if (locale === "de") return de_admin_resources_number(inputs)
	if (locale === "es") return es_admin_resources_number(inputs)
	if (locale === "fr") return fr_admin_resources_number(inputs)
	if (locale === "nl") return nl_admin_resources_number(inputs)
	if (locale === "it") return it_admin_resources_number(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_number(inputs)
	if (locale === "pl") return pl_admin_resources_number(inputs)
	if (locale === "hu") return hu_admin_resources_number(inputs)
	return ro_admin_resources_number(inputs)
});
export { admin_resources_number as "admin.resources.number" }